import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DisabledWhileOfflineDirective } from 'src/app/shared/directives/disabled-while-offline/disabled-while-offline.directive';
import { TranslateModule } from '@ngx-translate/core';

/**
 * @deprecated Prefer `StatusPageComponent` (`mytc-status-page`) for new error states.
 * `ErrorPageComponent` uses an older visual style that is no longer aligned with current designs.
 */
@Component({
  selector: 'mytc-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DisabledWhileOfflineDirective, TranslateModule],
})
export class ErrorPageComponent {
  @Input({ required: true }) title: string;
  @Input() additionalText: string;
  @Input() showRetryButton = false;

  @Output() retry = new EventEmitter<void>();
}
